import { Component, computed, inject, Signal } from '@angular/core';
import { CombinedStore } from 'src/app/core/combined.store';
import { getProductInfo } from 'src/app/shared/constants/product.constants';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';
import { SvgViewerComponent } from '../svg-viewer/svg-viewer.component';

@Component({
  selector: 'app-advisor-journey-banner',
  standalone: true,
  templateUrl: './advisor-journey-banner.component.html',
  imports: [SvgViewerComponent],
})
export class AdvisorJourneyBannerComponent {
  private readonly store = inject(CombinedStore);

  protected readonly message: Signal<string> = computed(() => getProductInfo(this.store.path())?.name ?? '');

  svg = new SvgVM('assets/common/toast/info_reverse.svg', 'Advisor Journey Banner');
}
